/* eslint-disable max-len */

const DeviceModels = {
  A209: { name: 'EMBLEM™', type: 'S-ICD', text: 'S-ICD / EMBLEM™' },
  A219: { name: 'EMBLEM™ MRI', type: 'S-ICD', text: 'S-ICD / EMBLEM™ MRI' },
  D000: { name: 'ORIGEN™ MINI', type: 'ICD', text: 'ICD / ORIGEN™ MINI' },
  D001: { name: 'ORIGEN™ MINI', type: 'ICD', text: 'ICD / ORIGEN™ MINI' },
  D002: { name: 'ORIGEN™ MINI', type: 'ICD', text: 'ICD / ORIGEN™ MINI' },
  D003: { name: 'ORIGEN™ MINI', type: 'ICD', text: 'ICD / ORIGEN™ MINI' },
  D010: { name: 'INOGEN™ MINI', type: 'ICD', text: 'ICD / INOGEN™ MINI' },
  D011: { name: 'INOGEN™ MINI', type: 'ICD', text: 'ICD / INOGEN™ MINI' },
  D012: { name: 'INOGEN™ MINI', type: 'ICD', text: 'ICD / INOGEN™ MINI' },
  D013: { name: 'INOGEN™ MINI', type: 'ICD', text: 'ICD / INOGEN™ MINI' },
  D020: { name: 'DYNAGEN™ MINI', type: 'ICD', text: 'ICD / DYNAGEN™ MINI' },
  D021: { name: 'DYNAGEN™ MINI', type: 'ICD', text: 'ICD / DYNAGEN™ MINI' },
  D022: { name: 'DYNAGEN™ MINI', type: 'ICD', text: 'ICD / DYNAGEN™ MINI' },
  D023: { name: 'DYNAGEN™ MINI', type: 'ICD', text: 'ICD / DYNAGEN™ MINI' },
  D030: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D031: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D032: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D033: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D044: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D045: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D046: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D047: { name: 'AUTOGEN™ MINI', type: 'ICD', text: 'ICD / AUTOGEN™ MINI' },
  D050: { name: 'ORIGEN™ EL', type: 'ICD', text: 'ICD / ORIGEN™ EL' },
  D051: { name: 'ORIGEN™ EL', type: 'ICD', text: 'ICD / ORIGEN™ EL' },
  D052: { name: 'ORIGEN™ EL', type: 'ICD', text: 'ICD / ORIGEN™ EL' },
  D053: { name: 'ORIGEN™ EL', type: 'ICD', text: 'ICD / ORIGEN™ EL' },
  D120: { name: 'MOMENTUM™ EL', type: 'ICD', text: 'ICD / MOMENTUM™ EL' },
  D121: { name: 'MOMENTUM™ EL', type: 'ICD', text: 'ICD / MOMENTUM™ EL' },
  D140: { name: 'INOGEN™ EL', type: 'ICD', text: 'ICD / INOGEN™ EL' },
  D141: { name: 'INOGEN™ EL', type: 'ICD', text: 'ICD / INOGEN™ EL' },
  D142: { name: 'INOGEN™ EL', type: 'ICD', text: 'ICD / INOGEN™ EL' },
  D143: { name: 'INOGEN™ EL', type: 'ICD', text: 'ICD / INOGEN™ EL' },
  D150: { name: 'DYNAGEN™ EL', type: 'ICD', text: 'ICD / DYNAGEN™ EL' },
  D151: { name: 'DYNAGEN™ EL', type: 'ICD', text: 'ICD / DYNAGEN™ EL' },
  D152: { name: 'DYNAGEN™ EL', type: 'ICD', text: 'ICD / DYNAGEN™ EL' },
  D153: { name: 'DYNAGEN™ EL', type: 'ICD', text: 'ICD / DYNAGEN™ EL' },
  D160: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D161: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D162: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D163: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D174: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D175: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D176: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D177: { name: 'AUTOGEN™ EL', type: 'ICD', text: 'ICD / AUTOGEN™ EL' },
  D220: { name: 'VIGILANT™ EL', type: 'ICD', text: 'ICD / VIGILANT™ EL' },
  D221: { name: 'VIGILANT™ EL', type: 'ICD', text: 'ICD / VIGILANT™ EL' },
  D232: { name: 'VIGILANT™ EL', type: 'ICD', text: 'ICD / VIGILANT™ EL' },
  D233: { name: 'VIGILANT™ EL', type: 'ICD', text: 'ICD / VIGILANT™ EL' },
  D320: { name: 'CHARISMA™ EL', type: 'ICD', text: 'ICD / CHARISMA™ EL' },
  D321: { name: 'CHARISMA™ EL', type: 'ICD', text: 'ICD / CHARISMA™ EL' },
  D332: { name: 'CHARISMA™ EL', type: 'ICD', text: 'ICD / CHARISMA™ EL' },
  D333: { name: 'CHARISMA™ EL', type: 'ICD', text: 'ICD / CHARISMA™ EL' },
  D400: { name: 'PERCIVA™ MINI', type: 'ICD', text: 'ICD / PERCIVA™ MINI' },
  D401: { name: 'PERCIVA™ MINI', type: 'ICD', text: 'ICD / PERCIVA™ MINI' },
  D412: { name: 'PERCIVA™ MINI', type: 'ICD', text: 'ICD / PERCIVA™ MINI' },
  D413: { name: 'PERCIVA™ MINI', type: 'ICD', text: 'ICD / PERCIVA™ MINI' },
  D420: { name: 'RESONATE™ EL', type: 'ICD', text: 'ICD / RESONATE™ EL' },
  D421: { name: 'RESONATE™ EL', type: 'ICD', text: 'ICD / RESONATE™ EL' },
  D432: { name: 'RESONATE™ EL', type: 'ICD', text: 'ICD / RESONATE™ EL' },
  D433: { name: 'RESONATE™ EL', type: 'ICD', text: 'ICD / RESONATE™ EL' },
  D500: { name: 'PERCIVA™ HF', type: 'ICD', text: 'ICD / PERCIVA™ HF' },
  D501: { name: 'PERCIVA™ HF', type: 'ICD', text: 'ICD / PERCIVA™ HF' },
  D512: { name: 'PERCIVA™ HF', type: 'ICD', text: 'ICD / PERCIVA™ HF' },
  D513: { name: 'PERCIVA™ HF', type: 'ICD', text: 'ICD / PERCIVA™ HF' },
  D520: { name: 'RESONATE™ HF', type: 'ICD', text: 'ICD / RESONATE™ HF' },
  D521: { name: 'RESONATE™ HF', type: 'ICD', text: 'ICD / RESONATE™ HF' },
  D532: { name: 'RESONATE™ HF', type: 'ICD', text: 'ICD / RESONATE™ HF' },
  D533: { name: 'RESONATE™ HF', type: 'ICD', text: 'ICD / RESONATE™ HF' },
  E050: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  E051: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  E052: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  E053: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  E102: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  E103: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  E110: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  E111: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  E140: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  E141: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  E142: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  E143: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  E160: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  E161: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  E162: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  E163: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  F050: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  F052: { name: 'PUNCTUA™', type: 'ICD', text: 'ICD / PUNCTUA™' },
  F102: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  F103: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  F110: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  F111: { name: 'TELIGEN™', type: 'ICD', text: 'ICD / TELIGEN™' },
  F140: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  F141: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  F142: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  F143: { name: 'ENERGEN™', type: 'ICD', text: 'ICD / ENERGEN™' },
  F160: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  F161: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  F162: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  F163: { name: 'INCEPTA™', type: 'ICD', text: 'ICD / INCEPTA™' },
  G050: { name: 'ORIGEN™', type: 'CRT-D', text: 'CRT-D / ORIGEN™' },
  G051: { name: 'ORIGEN™', type: 'CRT-D', text: 'CRT-D / ORIGEN™' },
  G056: { name: 'ORIGEN™ X4', type: 'CRT-D', text: 'CRT-D / ORIGEN™ X4' },
  G058: { name: 'ORIGEN™ X4', type: 'CRT-D', text: 'CRT-D / ORIGEN™ X4' },
  G124: { name: 'MOMENTUM™', type: 'CRT-D', text: 'CRT-D / MOMENTUM™' },
  G125: { name: 'MOMENTUM™', type: 'CRT-D', text: 'CRT-D / MOMENTUM™' },
  G126: { name: 'MOMENTUM™', type: 'CRT-D', text: 'CRT-D / MOMENTUM™' },
  G128: { name: 'MOMENTUM™ X4', type: 'CRT-D', text: 'CRT-D / MOMENTUM™ X4' },
  G138: { name: 'MOMENTUM™ X4', type: 'CRT-D', text: 'CRT-D / MOMENTUM™ X4' },
  G140: { name: 'INOGEN™', type: 'CRT-D', text: 'CRT-D / INOGEN™' },
  G141: { name: 'INOGEN™', type: 'CRT-D', text: 'CRT-D / INOGEN™' },
  G146: { name: 'INOGEN™ X4', type: 'CRT-D', text: 'CRT-D / INOGEN™ X4' },
  G148: { name: 'INOGEN™ X4', type: 'CRT-D', text: 'CRT-D / INOGEN™ X4' },
  G150: { name: 'DYNAGEN™', type: 'CRT-D', text: 'CRT-D / DYNAGEN™' },
  G151: { name: 'DYNAGEN™', type: 'CRT-D', text: 'CRT-D / DYNAGEN™' },
  G154: { name: 'DYNAGEN™', type: 'CRT-D', text: 'CRT-D / DYNAGEN™' },
  G156: { name: 'DYNAGEN™ X4', type: 'CRT-D', text: 'CRT-D / DYNAGEN™ X4' },
  G158: { name: 'DYNAGEN™ X4', type: 'CRT-D', text: 'CRT-D / DYNAGEN™ X4' },
  G160: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G161: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G164: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G166: { name: 'AUTOGEN™ X4', type: 'CRT-D', text: 'CRT-D / AUTOGEN™ X4' },
  G168: { name: 'AUTOGEN™ X4', type: 'CRT-D', text: 'CRT-D / AUTOGEN™ X4' },
  G172: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G173: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G175: { name: 'AUTOGEN™', type: 'CRT-D', text: 'CRT-D / AUTOGEN™' },
  G177: { name: 'AUTOGEN™ X4', type: 'CRT-D', text: 'CRT-D / AUTOGEN™ X4' },
  G179: { name: 'AUTOGEN™ X4', type: 'CRT-D', text: 'CRT-D / AUTOGEN™ X4' },
  G224: { name: 'VIGILANT™', type: 'CRT-D', text: 'CRT-D / VIGILANT™' },
  G225: { name: 'VIGILANT™', type: 'CRT-D', text: 'CRT-D / VIGILANT™' },
  G228: { name: 'VIGILANT™ X4', type: 'CRT-D', text: 'CRT-D / VIGILANT™ X4' },
  G237: { name: 'VIGILANT™ X4', type: 'CRT-D', text: 'CRT-D / VIGILANT™ X4' },
  G247: { name: 'VIGILANT™ X4', type: 'CRT-D', text: 'CRT-D / VIGILANT™ X4' },
  G248: { name: 'VIGILANT™ X4', type: 'CRT-D', text: 'CRT-D / VIGILANT™ X4' },
  G324: { name: 'CHARISMA™', type: 'CRT-D', text: 'CRT-D / CHARISMA™' },
  G325: { name: 'CHARISMA™', type: 'CRT-D', text: 'CRT-D / CHARISMA™' },
  G328: { name: 'CHARISMA™ X4', type: 'CRT-D', text: 'CRT-D / CHARISMA™ X4' },
  G337: { name: 'CHARISMA™ X4', type: 'CRT-D', text: 'CRT-D / CHARISMA™ X4' },
  G347: { name: 'CHARISMA™ X4', type: 'CRT-D', text: 'CRT-D / CHARISMA™ X4' },
  G348: { name: 'CHARISMA™ X4', type: 'CRT-D', text: 'CRT-D / CHARISMA™ X4' },
  G424: { name: 'RESONATE™', type: 'CRT-D', text: 'CRT-D / RESONATE™' },
  G425: { name: 'RESONATE™', type: 'CRT-D', text: 'CRT-D / RESONATE™' },
  G426: { name: 'RESONATE™', type: 'CRT-D', text: 'CRT-D / RESONATE™' },
  G428: { name: 'RESONATE™ X4', type: 'CRT-D', text: 'CRT-D / RESONATE™ X4' },
  G437: { name: 'RESONATE™ X4', type: 'CRT-D', text: 'CRT-D / RESONATE™ X4' },
  G447: { name: 'RESONATE™ X4', type: 'CRT-D', text: 'CRT-D / RESONATE™ X4' },
  G448: { name: 'RESONATE™ X4', type: 'CRT-D', text: 'CRT-D / RESONATE™ X4' },
  G524: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G525: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G526: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G528: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G537: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G547: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  G548: { name: 'RESONATE™ HF', type: 'CRT-D', text: 'CRT-D / RESONATE™ HF' },
  J062: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  J063: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  J064: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  J065: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  J066: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  J067: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  J172: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  J173: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  J174: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  J175: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  J176: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  J177: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  J178: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  J272: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  J273: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  J274: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  J275: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  J276: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  J277: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  J278: { name: 'FORMIO™', type: 'Pacemaker', text: 'Pacemaker / FORMIO™' },
  J279: {
    name: 'FORMIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / FORMIO™ MRI',
  },
  K062: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K063: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K064: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K065: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K066: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K067: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K082: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K083: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K084: {
    name: 'ADVANTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™',
  },
  K085: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K086: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K087: {
    name: 'ADVANTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ADVANTIO™ MRI',
  },
  K089: { name: 'FORMIO™', type: 'Pacemaker', text: 'Pacemaker / FORMIO™' },
  K172: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K173: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K174: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K175: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K176: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K177: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K182: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K183: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K184: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K185: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K186: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K187: {
    name: 'INGENIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / INGENIO™ MRI',
  },
  K188: { name: 'INGENIO™', type: 'Pacemaker', text: 'Pacemaker / INGENIO™' },
  K272: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K273: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K274: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K275: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K276: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K277: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K278: { name: 'FORMIO™', type: 'Pacemaker', text: 'Pacemaker / FORMIO™' },
  K279: {
    name: 'FORMIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / FORMIO™ MRI',
  },
  K282: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K283: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K284: { name: 'VITALIO™', type: 'Pacemaker', text: 'Pacemaker / VITALIO™' },
  K285: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K286: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K287: {
    name: 'VITALIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / VITALIO™ MRI',
  },
  K288: { name: 'FORMIO™', type: 'Pacemaker', text: 'Pacemaker / FORMIO™' },
  K289: {
    name: 'FORMIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / FORMIO™ MRI',
  },
  L100: {
    name: 'ESSENTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™',
  },
  L101: {
    name: 'ESSENTIO™',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™',
  },
  L110: {
    name: 'ESSENTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™ MRI',
  },
  L111: {
    name: 'ESSENTIO™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™ MRI',
  },
  L121: {
    name: 'ESSENTIO™ EL',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™ EL',
  },
  L131: {
    name: 'ESSENTIO™ MRI EL',
    type: 'Pacemaker',
    text: 'Pacemaker / ESSENTIO™ MRI EL',
  },
  L200: {
    name: 'PROPONENT™',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™',
  },
  L201: {
    name: 'PROPONENT™',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™',
  },
  L209: {
    name: 'PROPONENT™ VDD',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™ VDD',
  },
  L210: {
    name: 'PROPONENT™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™ MRI',
  },
  L211: {
    name: 'PROPONENT™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™ MRI',
  },
  L221: {
    name: 'PROPONENT™ EL',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™ EL',
  },
  L231: {
    name: 'PROPONENT™ MRI EL',
    type: 'Pacemaker',
    text: 'Pacemaker / PROPONENT™ MRI EL',
  },
  L300: {
    name: 'ACCOLADE™',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™',
  },
  L301: {
    name: 'ACCOLADE™',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™',
  },
  L310: {
    name: 'ACCOLADE™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™ MRI',
  },
  L311: {
    name: 'ACCOLADE™ MRI',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™ MRI',
  },
  L321: {
    name: 'ACCOLADE™ EL',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™ EL',
  },
  L331: {
    name: 'ACCOLADE™ MRI EL',
    type: 'Pacemaker',
    text: 'Pacemaker / ACCOLADE™ MRI EL',
  },
  N050: { name: 'PUNCTUA™', type: 'CRT-D', text: 'CRT-D / PUNCTUA™' },
  N051: { name: 'PUNCTUA™', type: 'CRT-D', text: 'CRT-D / PUNCTUA™' },
  N052: { name: 'PUNCTUA™', type: 'CRT-D', text: 'CRT-D / PUNCTUA™' },
  N053: { name: 'PUNCTUA™', type: 'CRT-D', text: 'CRT-D / PUNCTUA™' },
  N106: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  N107: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  N108: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  N118: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  N119: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  N140: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  N141: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  N142: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  N143: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  N160: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  N161: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  N162: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  N163: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  N164: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  N165: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  P052: { name: 'PUNCTUA™', type: 'CRT-D', text: 'CRT-D / PUNCTUA™' },
  P106: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  P107: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  P108: { name: 'COGNIS™', type: 'CRT-D', text: 'CRT-D / COGNIS™' },
  P142: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  P143: { name: 'ENERGEN™', type: 'CRT-D', text: 'CRT-D / ENERGEN™' },
  P162: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  P163: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  P165: { name: 'INCEPTA™', type: 'CRT-D', text: 'CRT-D / INCEPTA™' },
  U125: { name: 'VALITUDE™', type: 'CRT-P', text: 'CRT-P / VALITUDE™' },
  U128: { name: 'VALITUDE™ X4', type: 'CRT-P', text: 'CRT-P / VALITUDE™ X4' },
  U225: { name: 'VISIONIST™', type: 'CRT-P', text: 'CRT-P / VISIONIST™' },
  U226: { name: 'VISIONIST™', type: 'CRT-P', text: 'CRT-P / VISIONIST™' },
  U228: {
    name: 'VISIONIST™ X4',
    type: 'CRT-P',
    text: 'CRT-P / VISIONIST™ X4',
  },
  V172: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  V173: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  V182: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  V183: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  V272: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  V273: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  V282: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  V283: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  V284: { name: 'INLIVEN™', type: 'CRT-P', text: 'CRT-P / INLIVEN™' },
  V285: { name: 'INLIVEN™', type: 'CRT-P', text: 'CRT-P / INLIVEN™' },
  W172: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  W173: { name: 'INVIVE™', type: 'CRT-P', text: 'CRT-P / INVIVE™' },
  W272: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  W273: { name: 'INTUA™', type: 'CRT-P', text: 'CRT-P / INTUA™' },
  W274: { name: 'INLIVEN™', type: 'CRT-P', text: 'CRT-P / INLIVEN™' },
  W275: { name: 'INLIVEN™', type: 'CRT-P', text: 'CRT-P / INLIVEN™' },
}

// export default DeviceModels
module.exports = DeviceModels
